// Presentation only: matching, totals validation and procedural closure belong to the backend.
export const isCentimos = value => Number.isSafeInteger(value) && value >= 0;

export function euros(value) {
    return isCentimos(value)
        ? (value / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })
        : 'No informado';
}

export function fechaBancaria(value) {
    if (!value || value === '00000000') return 'No informada';
    const raw = String(value);
    return /^\d{8}$/.test(raw) ? `${raw.slice(6, 8)}/${raw.slice(4, 6)}/${raw.slice(0, 4)}` : raw;
}

export function fechaRecepcion(value) {
    if (!value) return 'No informada';
    // SQLite CURRENT_TIMESTAMP is UTC, not browser-local time.
    const raw = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)
        ? `${value.replace(' ', 'T')}Z` : value;
    const date = new Date(raw);
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString('es-ES');
}

export function levantadoEfectivo(data, fase) {
    return Number(fase) === 6 && isCentimos(data?.retenido_centimos) && isCentimos(data?.neto_centimos)
        && data.neto_centimos <= data.retenido_centimos
        ? data.retenido_centimos - data.neto_centimos : null;
}

export function textoAviso(value) {
    if (typeof value === 'string') return value;
    return value?.message || value?.mensaje || value?.error || JSON.stringify(value);
}

export function errorRetorno(error) {
    const data = error?.response?.data;
    const code = data?.code;
    const message = typeof data?.error === 'string' ? data.error : error?.message || 'No se pudo completar la operación.';
    return { message, code, status: error?.response?.status };
}

function importesCompletos(data, fase, cuenta = false) {
    return data && isCentimos(data.retenido_centimos) && (cuenta || isCentimos(data.ordenado_centimos))
        && (fase === 4 || (isCentimos(data.neto_centimos) && (cuenta || isCentimos(data.levantamiento_centimos))));
}

export function previewConfirmable(data) {
    const fase = Number(data?.fase);
    return Boolean(data?.valido === true && typeof data.token === 'string' && data.token.length > 0
        && typeof data.sha256 === 'string' && /^[a-f0-9]{64}$/i.test(data.sha256)
        && [4, 6].includes(fase) && /^\d{4}$/.test(data.nrbe || '')
        && Number(data.cabecera?.fase) === fase && data.cabecera?.nrbe === data.nrbe
        && /^\d{8}$/.test(data.cabecera?.fecha_obtencion || '') && /^\d{8}$/.test(data.cabecera?.fecha_entidad || '')
        && importesCompletos(data.resumen, fase) && Array.isArray(data.avisos)
        && Array.isArray(data.detalles) && data.detalles.length > 0
        && data.detalles.every(d => d.nif && d.identificador_deuda && importesCompletos(d, fase)
            && Array.isArray(d.cuentas) && d.cuentas.length > 0
            && d.cuentas.every(c => c.iban && c.resultado != null && importesCompletos(c, fase, true))));
}

export function bindingVigente(binding, file, preview, sequence) {
    return Boolean(binding && file && preview && binding.file === file
        && binding.token === preview.token && binding.sequence === sequence);
}

export function historicoValido(data) {
    return Boolean(data && Array.isArray(data.recepciones) && Array.isArray(data.bancos)
        && ['pendiente', 'cerrado'].includes(data.estado_global) && data.contabilidad === 'fuera_de_alcance');
}

export function resultadoLevantamiento(code) {
    const labels = { '0': 'Sin orden de levantamiento', '1': 'Levantamiento total', '2': 'Levantamiento parcial', '3': 'Levantamiento rechazado', '4': 'Otros motivos' };
    if (code == null || code === '') return 'No comunicado';
    return `${code} · ${labels[String(code)] || 'Resultado comunicado por la entidad'}`;
}

export const textoEstado = value => value ? String(value).replaceAll('_', ' ') : 'No informado';
